import {Component, Inject, inject, OnInit, ViewChild} from '@angular/core';
import {Charger} from "../../Ope/Charger/Charger";
import {MatTableDataSource} from "@angular/material/table";
import {PageEvent} from "@angular/material/paginator";
import {ChargerService} from "../../Services/Ope/Charger.service";
import {GetChargersCB} from "../../Ope/Charger/GetChargersCB";
import {BaseComponent} from "../common/BaseComponent";
import {BaseDialogComponent} from "../common/BaseDialogComponent";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {PutChargerCB} from "../../Ope/Charger/PutChargerCB";
import {DelChargerCB} from "../../Ope/Charger/DelChargerCB";
import {AreUSureDeleteCustomerDialogComponent} from "../customerRegistry/customerRegistry.component";
import {CustomerUserDetailComponent} from "../customerUserRegistry/customerUserDetail/customerUserDetail.component";
import {ChargerDetailComponent} from "./chargerDetail/chargerDetail.component";

@Component({
  selector: 'app-chargerRegistry',
  templateUrl: './chargerRegistry.component.html',
  styleUrls: ['./chargerRegistry.component.css', '../common/drawer-style.css']
})
export class ChargerRegistryComponent extends BaseComponent implements OnInit {

  @ViewChild(ChargerDetailComponent) chargerDetail?: ChargerDetailComponent;

  readonly PAGESIZE_OPTIONS = [10, 20, 30];
  totalPages?: number;
  totalElements: number = 0;
  page = 0;
  pageSize = this.PAGESIZE_OPTIONS[0];

  displayedColumns: string[] = ['chargerName', 'chargerPower','label' ,'actions'];
  chargers?: Charger[]
  searchEnabled:boolean = false;
  chargerNameToFind?: string;
  tableDataSource!: MatTableDataSource<Charger>;
  expandedElement?: Charger;
  chargerLoading: boolean = false;

  editMode: boolean = false;
  formValidationOk = true;

  private chargerService = inject(ChargerService);
  newCharger?: Charger;

  ngOnInit(): void {
    this.getChargers();
  }
  constructor() {
    super();
  }

  getChargers() {
    this.chargerLoading = true;
    this.tableDataSource = new MatTableDataSource();
    const cb = new GetChargersCB();
    cb.i.pageSize = this.pageSize;
    cb.i.page = this.page;
    cb.i.textSearch = (!!this.chargerNameToFind && this.chargerNameToFind != '') ? this.chargerNameToFind : undefined;

    this.chargerService.getChargers(cb).subscribe(
      () => {
        this.chargers = cb.o.chargers.sort((a,b) => a.name.localeCompare(b.name));
        this.totalElements = cb.o.totalElements;
        this.totalPages = cb.o.totalPages;
        this.tableDataSource = new MatTableDataSource(this.chargers);
        this.chargerLoading = false;
        // Update the Expanded element
        if (!!this.expandedElement) {
          this.expandedElement = this.chargers.find(a => a.id === this.expandedElement?.id);
        }
        this.editMode = false;
      }, error => {
        this.gmService.openErrorSnackbar(error);
        this.tableDataSource = new MatTableDataSource();
        this.chargerLoading = false;
      }
    )
  }
  addNewCharger() {

    this.newCharger = new Charger();

    const dialogRef = this.dialog.open(PutChargerDialogComponent, {
      width: '600px',
      data: {
        charger: this.newCharger,
      }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (!!res) {
          this.gmService.openSuccessSnackbar(this.translate.instant('CHARGER.ADD_OK'));
          this.getChargers();
        }
      }, error => {
        console.log(error);
      }
    );
  }



  showDetail(row: Charger) {
    this.editMode = false;
    this.expandedElement = this.expandedElement === row ? undefined : row;
  }

  getPaginatorData(event: PageEvent): PageEvent {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getChargers();
    return event;
  }

  updateCharger() {
    const charger = this.chargerDetail?.dataDetail;
    if (!!charger) {
      const cb = new PutChargerCB();
      cb.i.charger = charger;
      this.chargerService.putCharger(cb).subscribe(
        () => {
          this.gmService.openSuccessSnackbar(this.translate.instant('CHARGER.UPDATE_OK'));
          this.getChargers();
        }, err1 => {
          this.gmService.openErrorSnackbar(err1);
        }
      )
    }
  }

  hideElement() {
    this.expandedElement = undefined;
  }

  manageFormValidation($event: boolean) {
    this.formValidationOk = $event;
  }

  deleteCharger(element: Charger) {
    const dialogRef = this.dialog.open(AreUSureDeleteChargerDialogComponent, {
      width: '500px',
      data: element.name.concat(" | " + element.wattPower + " W" )
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          const cb = new DelChargerCB();
          cb.i.id = element.id;

          this.chargerService.delCharger(cb).subscribe(
            () => {
              this.gmService.openSuccessSnackbar(this.translate.instant('CHARGER.DELETE_OK'));
              this.getChargers();
            }, error => {
              this.gmService.openErrorSnackbar(error);
            }
          )
        }
      })
  }
}

/*--------------------------------
      PUT CHARGER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: 'put-charger-dialog.html',
  selector: 'app-put-charger-dialog',
  styleUrls: ['../common/dialog-style.css', 'chargerRegistry.component.css']
})
export class PutChargerDialogComponent extends BaseDialogComponent<PutChargerDialogComponent> {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    data.charger.wattPower = 0;
  }

  private chargerService = inject(ChargerService);

  saveCharger(charger: Charger) {
    const cb = new PutChargerCB();
    cb.i.charger = charger;

    this.chargerService.putCharger(cb).subscribe(
      () => {
        this.closeDialog(true)
      }, err1 => {
        this.gmService.openErrorSnackbar(err1);
      }
    )
  }
}
/*--------------------------------
     DELETE CUSTOMER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: '../common/are-u-sure-delete-dialog.html',
  selector: 'app-are-u-sure-delete-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class AreUSureDeleteChargerDialogComponent extends BaseDialogComponent<AreUSureDeleteCustomerDialogComponent> {

  entity = "Connettore";

  constructor(@Inject(MAT_DIALOG_DATA) public customerTitle: string) {
    super();
  }

}
